"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakingDeployDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const types_1 = require("@framework/types");
const StakingDeployDialog = () => {
    return (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractTemplate", options: types_1.StakingContractTemplates });
};
exports.StakingDeployDialog = StakingDeployDialog;
//# sourceMappingURL=index.js.map